module.exports = __webpack_public_path__ + "img/installations.dfecb78a.svg";